import { render, staticRenderFns } from "./StatementDetailFac.vue?vue&type=template&id=25df43d8&scoped=true"
import script from "./StatementDetailFac.vue?vue&type=script&lang=js"
export * from "./StatementDetailFac.vue?vue&type=script&lang=js"
import style0 from "./StatementDetailFac.vue?vue&type=style&index=0&id=25df43d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df43d8",
  null
  
)

export default component.exports